import './ActivityIndicator.scss';
import * as React from 'react';
type Props = {
  height: string;
  message?: string;
};
/**
 * This component should be used anywhere we need a loading state. The height
 * prop determines how tall the loading state will be. The height should never
 * be smaller than 3em.
 */
export default class ActivityIndicator extends React.Component<Props> {
  static defaultProps = {
    height: '12em',
  };
  render() {
    const { message } = this.props;
    return (
      <div
        className="ActivityIndicator"
        style={{
          height: this.props.height,
        }}
      >
        <div className="ActivityIndicator-spinner" />
        {message && <div className="ActivityIndicator-message">{message}</div>}
      </div>
    );
  }
}
